export default __webpack_public_path__ + "static/media/393.4cb327a5.gif";